import { Observable } from 'rxjs';
import { ActionsObservable } from 'redux-observable';
import _ from 'lodash';

import CauseApi from 'entities/cause/api';

import { INIT, InitAction, initSuccessAction, initFailedAction } from './types';

const init = (action$: ActionsObservable<InitAction>) =>
  action$.ofType(INIT).mergeMap(() => {
    const actions = [];

    actions.push(CauseApi.fetchAll());

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

export default [init];
